<template>
  <div class="main" ref="stepContainer">
    <div
      class="position-relative d-flex justify-content-between text-center"
      style="min-width: fit-content;"
    >
      <div class="horizontal-line"></div>
      <div
        class="step-container d-flex flex-column align-items-center justify-items-center"
        v-for="(step, stepIndex) in steps"
        :key="stepIndex"
        :id="step.type"
      >
        <span :class="stepIndex === value ? 'active' : 'disabled'">
          {{ step.title }}
        </span>

        <div
          :class="stepIndex === value ? 'step-selected' : 'step-disabled'"
          class="step-circle d-flex justify-content-center align-items-center"
        >
          <span class="step-index" v-if="!step.result">
            {{ stepIndex + 1 }}
          </span>
          <i v-else class="fa fa-check" aria-hidden="true"></i>
        </div>
        <span
          :style="
            step.result && step.result.length > 30 ? 'width: 150px' : null
          "
          class="result d-flex justify-content-center"
        >
          {{ getResult(step.result) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentRequestSteps",
  props: ["value", "steps"],
  data() {
    return {};
  },
  methods: {
    getResult(result) {
      return result && result.length > 26
        ? result.replace(result.substring(26), "...")
        : result;
    }
  },
  computed: {
    isSmallDevice() {
      return window.innerWidth < 576 ? true : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.active {
  color: #0084ff;
  font-size: 14px;
}
.disabled {
  color: #d0d0d0;
  font-size: 14px;
}
.horizontal-line {
  position: absolute;
  left: 62px;
  right: 62px;
  top: 33px;
  height: 1px;
  border-bottom: 5px solid #ececec;
}
.step-circle {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background-color: #c9c9c9;
  text-align: center;
  color: #fbfbfb;
}
.step-container {
  z-index: 1;
  min-width: 135px;
}

.step-selected {
  background-color: #0084ff;
}

.step-disabled {
  background-color: #c9c9c9;
}

.result {
  color: #60d668;
  /* width: 75%; */
  font-size: 12px;
}

@media screen and (max-width: 576px) {
  .step-circle {
    width: 30px;
    height: 30px;
  }
}

.main {
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-bottom: 15px;
}
</style>
